import { createFileRoute } from '@tanstack/react-router'

import { ApiKeys } from '@/widgets/api-keys'

export const Route = createFileRoute('/_app/api-keys')({
  component: RouteComponent,
})

export const ApiKeysRoute = Route

function RouteComponent() {
  return <ApiKeys />
}
